import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronRight } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Left } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { PageHeader } from '../../../../components/PageHeader';
import { selectWorks } from '../../../Api/selectors';
import {
  createVehicleWithProps,
  fromAutotelex,
  initiateVehicleCreate,
  setNewVehicleValue,
  setVehicleProperties,
} from '../../actions';
import { REQUEST_AUTOTELEX_APPLY_OPTIONS, REQUEST_VEHICLE, REQUEST_VEHICLE_FROM_AUTOTELEX } from '../../constants';
import { selectNewVehicle, selectVehicles } from '../../selectors';
import { StepperCreateHeader } from './Header';
import { VehicleCreateStep1 } from './Step1Base';
import { VehicleCreateStep2 } from './SecondStep/SecondStep';
import { VehicleCreateStep3 } from './ThirdStep/ThirdStep';
import { VehicleCreateStep4 } from './FourthStep/FourthStep';
import { VehicleCreateStep5 } from './FifthStep/FifthStep';
import { VehicleCreateStep6 } from './SixtStep/SixtStep';

import { VehicleCreateInfo } from './VehicleCreateInfoCard';
import { resetProperties } from '../../helpers';
import { HBox } from '../../../../components/Box';
const Container = styled.div`
  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;
    @media (max-width: 768px) {
      width: 100%;
      min-width: 250px;
    }
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
  }
  .form-block {
    display: flex;
    align-items: baseline;
    flex-direction: row;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      gap: 24px;
    }
  }
`;

const STATE = {
  step: 1,
  creditorInfo: null,
  resultId: null,
  stepperClickStep: null,
  stepperClick: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.init();
  }

  componentDidUpdate(prevProps) {
    if (this.state.step === 6) {
      this.to(`/vehicles/${this.props.match.params.vehicleId}`);
    }
  }

  get vehicle() {
    return this.props.vehicle;
  }

  create() {
    this.props.create(this.properties, this.options, result => {
      this.to(`/vehicles/${result.id}`);
    });
  }

  save(callback) {
    this.setState({ saving: true }, () => {
      let properties = [];

      for (let i in this.props.values) {
        if (this.props.values[i] !== '') {
          properties.push({
            propertyName: i,
            propertyValue: this.props.values[i],
          });
        }
      }

      const resetTypes = resetProperties(this.props.step);

      if (this.props.step === 1) {
        this.props.create(properties, [], result => {
          if (result.id) {
            this.getCreditorInfo({
              creditorCompanyId: result['creditorCompany']?.id,
              creditorId: result['creditor']?.id,
            });

            this.setState(prevState => ({
              saving: false,
              ...this.state,
              step: (prevState.step += 1),
              resultId: result.id,
            }));

            if (callback) {
              callback(result.id);
            } else {
              this.state.stepperClick && result['creditor_company']?.id
                ? this.to(`/vehicles/${result.id}/edit/${this.state.stepperClickStep}`)
                : this.to(`/vehicles/${result.id}/edit/${this.state.step}`);
            }
          }
        });
      } else {
        this.props.patch(this.state.resultId, properties, result => {
          this.setState(prevState => ({
            saving: false,
            ...this.state,
            step: (prevState.step += 1),
          }));
        });
      }

      this.props.resetValues(resetTypes);
    });
  }

  getStep(n) {
    n && this.setState({ stepperClickStep: n, stepperClick: true });
  }

  prevStep() {
    this.setState(prevState => ({
      ...this.state,
      step: prevState.step - 1,
    }));
  }

  getCreditorInfo(info) {
    this.setState({ ...this.state, creditorInfo: info });
  }

  render() {
    if (this.props.work || this.state.saving) {
      return (
        <HBox center>
          <Loader />
        </HBox>
      );
    }

    //wait for ID to clear
    if (this.props.values.id) {
      return <Loader small />;
    }
    return (
      <Container>
        <PageHeader
          title={
            <div onClick={this.tofn(`${this.vehicle ? `/vehicles/${this.vehicle.id}` : `/vehicles`}`)}>
              <Left />
              {this.lbl('vehicles')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('vehicles')}
              <ChevronRight />

              {this.lbl('add')}
            </>
          }
        />
        <StepperCreateHeader
          steps_quantity={6}
          model={'vehicle'}
          step={this.props.step}
          labelArr={['Basic data', 'Financial data', 'RDW in history', 'Documents', 'Vehicle data', 'Advertising data']}
          onSave={this.props.values.creditor_company && this.save.bind(this)}
          getStep={this.getStep.bind(this)}
        />
        <div className="form-block">
          {this.props.step === 1 && (
            <VehicleCreateStep1
              onSave={this.save.bind(this)}
              fetchFromAutotelex={regplate => {
                this.save(vehicle_id => {
                  this.props.fetchFromAutotelex(vehicle_id, regplate, () => {
                    this.to(`/vehicles/${vehicle_id}/edit/1`);
                  });
                });
              }}
            />
          )}
          {this.props.step === 2 && this.state.creditorInfo && (
            <VehicleCreateStep2
              creditorInfo={this.state.creditorInfo}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.props.step === 3 && (
            <VehicleCreateStep3 onSave={this.save.bind(this)} getPrevStep={this.prevStep.bind(this)} />
          )}
          {this.props.step === 4 && this.props.match.params.vehicleId && (
            <VehicleCreateStep4
              vehicle_id={+this.props.match.params.vehicleId}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.props.step === 5 && (
            <VehicleCreateStep5 
            onSave={this.save.bind(this)} 
            
            getPrevStep={this.prevStep.bind(this)} />
          )}
           {this.props.step === 6 && (
            <VehicleCreateStep6 
            vehicle_id={+this.props.match.params.vehicleId}
            onSave={this.save.bind(this)} 
            
            getPrevStep={this.prevStep.bind(this)} />
          )}
          {this.props.step > 1 && this.props.match.params.vehicleId && (
            <VehicleCreateInfo
              vehicle_id={+this.props.match.params.vehicleId}
              data={['regplate', 'brand_name', 'model_name', 'date_first_allowance', 'mileage', 'base_color', 'fuel_type']}
            />
          )}
        </div>
      </Container>
    );
  }
}

VehicleCreateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE, REQUEST_VEHICLE_FROM_AUTOTELEX, REQUEST_AUTOTELEX_APPLY_OPTIONS]),
    values: selectNewVehicle(),
    allVehicles: selectVehicles(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateVehicleCreate());
    },
    create(properties, options, callback) {
      dispatch(createVehicleWithProps(properties, options, callback));
    },
    patch(id, props, callback) {
      dispatch(setVehicleProperties(id, props, callback));
    },
    resetValues(values, name = null) {
      values.map(type => dispatch(setNewVehicleValue(type, '')));
    },
    fetchFromAutotelex(vehicle_id, regplate, callback) {
      dispatch(fromAutotelex(vehicle_id, regplate, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleCreate = compose(
  withConnect,
  withRouter,
)(VehicleCreateComp);
